import { createSelector } from '@ngrx/store';

import { createSingleEntityStore } from '@core/ngrx-legacy';
import { AnalyticsDevFlag, AnalyticsDevFlagsMap } from '@core/reports-types';

import { INITIAL_STATE } from './utils';

const { selectors, reducer, namespace, actions } = createSingleEntityStore<AnalyticsDevFlagsMap>()(
  'AnalyticsDevFlags',
  {
    initialState: INITIAL_STATE,
  },
);

const isEnabled = (props: { flag: AnalyticsDevFlag }) =>
  createSelector(selectors.data, state => (state ? state[props.flag] : false));

const AnalyticsDevFlagsSelectors = {
  ...selectors,
  isEnabled,
};

export {
  AnalyticsDevFlagsSelectors,
  actions as AnalyticsDevFlagsActions,
  namespace as AnalyticsDevFlagsNamespace,
  reducer as AnalyticsDevFlagsReducer,
};
